<template>
  <div @click="click">
    <template v-if="config !== undefined">
      <template v-if="config.group === 'custom'">
        Individuelle Werkzeuglösung
      </template>
      <template v-else>
        {{ config.model }}
      </template>
      <i class="delete-icon icon-close" title="Schnitt löschen" @click.stop="$emit('delete')"></i>
    </template>
  </div>
</template>

<script>
/* eslint-disable */
import Options from '@/Options'

export default {
  name: 'ConfigView',
  components: {
  },
  props: ['config'],
  data () {
    return {
      loading: true,
    }
  },
  methods: {
    click () {
      this.$emit('select')
    }
  },
  computed: {
    opts () {
      return this.options.options[this.config.group][this.config.model].options
    },
    structure () {
      return this.options.structures[this.config.group][this.config.model]
    }
  },
  mounted () {
    Options.getOptions().then(options => {
      this.options = options
      this.loading = false
    })
  }
}
</script>

<style scoped>
.delete-icon {
  font-size: 11px;
  margin-left: 18px;
  color: #e6e6e6
}
.delete-icon:hover {
  color: #54565a;
}
</style>



// WEBPACK FOOTER //
// src/components/ConfigView.vue